import {
  Backdrop,
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { getPaymentBrandEventsDetails } from "../../../services/payment";
import { parseDate } from "../../../utils/tableFunctions";
import { Clear } from "@mui/icons-material";

const BrandDetails = ({ itemId, isViewHistory }) => {
  const [brandDetails, setbrandDetails] = useState();
  const [loaded, setLoaded] = useState();
  const { id = itemId } = useParams();
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const action = useQuery().get("action") || (isViewHistory && "true");
  const mobile = useMediaQuery((theme) => theme.breakpoints.down("lg"));

  useEffect(() => {
    getPaymentBrandEventsDetails(id, setbrandDetails, setLoaded);
  }, [action, id]);

  const handleBack = () => window.close();

  return (
    <Container>
      {!itemId && (
        <Stack
          direction="row"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <Typography variant={mobile ? "h5" : "h3"}>
            Brand History Details
          </Typography>

          <Button
            variant="outlined"
            onClick={handleBack}
            endIcon={<Clear />}
            sx={{ width: mobile ? "30%" : "15%" }}
          >
            Back
          </Button>
        </Stack>
      )}
      {loaded && action === "true" && (
        <Typography variant="h6" sx={{ mb: 2 }}>
          Action: {brandDetails.action && brandDetails.action}
        </Typography>
      )}
      {loaded ? (
        <Card sx={{ p: 3 }}>
          <Grid
            container
            direction={{ xs: "column", sm: "row" }}
            spacing={{ xs: 2, sm: 2, md: 2 }}
            sx={{ mt: 5 }}
          >
            <Grid item xs={6} md={6}>
              <Box
                sx={{
                  height: "100%",
                  p: 3,
                  border: "1px solid #999",
                  borderRadius: 2,
                }}
              >
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">Created on</Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {brandDetails.created_at
                      ? parseDate(brandDetails.created_at)
                      : "N/A"}
                  </Grid>
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">Created by</Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {brandDetails.created_by ? brandDetails.created_by.email : "N/A"}
                  </Grid>
                </Grid>
              </Box>
            </Grid>

            <Grid item xs={6} md={6}>
              <Box
                sx={{
                  height: "100%",
                  p: 3,
                  border: "1px solid #999",
                  borderRadius: 2,
                }}
              >
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">Payment Method</Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {brandDetails.name}
                  </Grid>
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">Action</Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {brandDetails.action}
                  </Grid>
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">Action Message</Typography>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    md={7}
                    sx={{
                      overflowWrap: "normal",
                      wordBreak: "break-word",
                    }}
                  >
                    {brandDetails.action_message}
                  </Grid>
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">
                      Payment Method/s
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    md={7}
                    sx={{
                      overflowWrap: "normal",
                      wordBreak: "break-word",
                    }}
                  >
                    {brandDetails.payment_method
                      .map((method) => method.name)
                      .join(", ")}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
          {brandDetails.reject_message && (
            <Typography variant="subtitle1" sx={{ mt: 2, display: "flex" }}>
              Reason for rejection:
              <Typography sx={{ ml: 1 }}>
                {" "}
                {brandDetails.reject_message}
              </Typography>
            </Typography>
          )}
          {brandDetails.action_message && (
            <Typography variant="subtitle1" sx={{ mt: 2, display: "flex" }}>
              Action message:
              <Typography sx={{ ml: 1 }}>
                {" "}
                {brandDetails.action_message}
              </Typography>
            </Typography>
          )}
        </Card>
      ) : (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </Container>
  );
};

export default BrandDetails;
